module.exports = __webpack_public_path__ + "img/05941209023207_C1C1_s15_100017387.d796f4b3.png";